// Depths of the farm backdrop's screen-fixed layers (the world container sits at 0, the HUD
// at 1000). Its own module so every backdrop part can import it without a cycle through
// FarmBackdrop.js.
export const DEPTH = {
  lawnFill: -31, sky: -30, stars: -29, meteor: -28, sunMoon: -27, farClouds: -26,
  far: -25, nearClouds: -23, mid: -22, midObjects: -21.5, birds: -20,
  worldHaze: 0.5, farmLight: 5, nearObjects: 6, near: 6.5, fireflies: 7,   // all below the MoneyBar (50)
};
